import { state, log, toast, beepShort, show } from './ui.js';
import { guessDeliveryParcel, sanitizeCode } from './flows.js';
import { saveCourierSettings, getCourierSettings } from './settings.js';

const LS_KEY = 'tsdMode';

export function tsdActive() {
  return document.body.classList.contains('tsd-mode');
}

function updateTsdButtonUI() {
  const btn = document.getElementById('btn_tsd');
  if (!btn) return;
  const on = tsdActive();
  btn.classList.toggle('primary', on);
  btn.title = on ? 'Режим ТЗД увімкнено' : 'Увімкнути режим ТЗД';
}

export function setTsdMode(on, { persistRemote = false, showToast = false } = {}) {
  const active = !!on;
  document.body.classList.toggle('tsd-mode', active);
  try {
    localStorage.setItem(LS_KEY, active ? '1' : '0');
  } catch (_) {}
  updateTsdButtonUI();
  const settings = getCourierSettings();
  if (settings) settings.tsdMode = active;
  if (showToast) toast(active ? 'Режим ТЗД: увімкнено' : 'Режим ТЗД: вимкнено');
  if (persistRemote) {
    saveCourierSettings({ tsdMode: active }).catch((err) => {
      log('settings:tsd_save_fail ' + (err?.message || err));
    });
  }
}

export function initTsdToggles() {
  function applySavedTsdMode() {
    let target = getCourierSettings().tsdMode;
    if (target == null) {
      try {
        target = localStorage.getItem(LS_KEY) === '1';
      } catch (_) {
        target = false;
      }
    }
    setTsdMode(!!target, { persistRemote: false, showToast: false });
  }
  document.getElementById('btn_tsd')?.addEventListener('click', () => {
    setTsdMode(!tsdActive(), { persistRemote: true, showToast: true });
  });
  applySavedTsdMode();
}

export function initTsdKeyboard(processPickupCode, startDeliveryFor, resolveLockerUrl) {
  let tsdBuf = '';
  let tsdTimer = null;
  let tsdPickupBusy = false;

  function visible(id) {
    const el = document.getElementById(id);
    return el && !el.classList.contains('hidden');
  }
  function looksLikeLockerRef(s) {
    return s.includes('://') || /^0x[0-9A-Fa-f]+$/.test(s) || /^[0-9A-Fa-f-]{32,36}$/.test(s);
  }
  function findPickupByCode(code) {
    const key = sanitizeCode(code);
    return state.pickupIndex[key] || null;
  }
  async function tsdPickupFlow(code) {
    if (tsdPickupBusy) return;
    const p = findPickupByCode(code);
    if (!p) {
      toast('Посилку не знайдено');
      return;
    }
    if (state.processedPickup.has(p.parcelID) || state.skippedPickup.has(p.parcelID)) {
      toast('Вже оброблено');
      return;
    }
    try {
      tsdPickupBusy = true;
      // open then process code
      await processPickupCode(p, code);
    } finally {
      tsdPickupBusy = false;
    }
  }
  async function processTsdScan(payload) {
    const code = (payload || '').trim();
    if (!code) return;
    log('TSD: ' + code);
    beepShort();
    if (visible('screen_start')) {
      if (looksLikeLockerRef(code)) {
        await resolveLockerUrl(code);
      } else {
        toast('Очікується QR поштомату');
      }
      return;
    }
    if (visible('screen_pickup')) {
      const panel = document.getElementById('pickup_scan_panel');
      if (panel && !panel.classList.contains('hidden')) {
        processPickupCode(null, code);
      } else {
        tsdPickupFlow(code);
      }
      return;
    }
    if (visible('screen_delivery')) {
      startDeliveryFor(code);
      return;
    }
  }

  window.addEventListener('keydown', (e) => {
    if (!tsdActive()) return;
    const ae = document.activeElement;
    if (ae && (ae.tagName === 'INPUT' || ae.tagName === 'TEXTAREA' || ae.isContentEditable)) return;
    const k = e.key;
    if (k === 'Enter') {
      const payload = tsdBuf;
      tsdBuf = '';
      if (tsdTimer) {
        clearTimeout(tsdTimer);
        tsdTimer = null;
      }
      if (payload) {
        e.preventDefault();
        void processTsdScan(payload);
      }
      return;
    }
    if (k.length === 1) {
      tsdBuf += k;
      if (tsdTimer) clearTimeout(tsdTimer);
      tsdTimer = setTimeout(() => {
        const p = tsdBuf;
        tsdBuf = '';
        void processTsdScan(p);
      }, 140);
    }
  });
}
